module.exports = __webpack_public_path__ + "static/img/two_1367beijindaxue.9fb6db4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_1367beijindaxue.jpg
// module id = cJ7P
// module chunks = 36